export default __webpack_public_path__ + "static/media/add-plus.93716e6d.svg";